import { useEffect } from "react";
import { eventService } from "@nf/common";
import { ROUTES } from "@nf/constants";
import { useRouter } from "./useRouter";

export const useSubProfileChangeEvent = () => {
  const router = useRouter();

  useEffect(() => {
    const subscription = eventService.onUserSubProfileChangeEvent(
      (initialHomePage?: string) => {
        router.replace(initialHomePage ?? ROUTES.HOME, undefined, {
          withLoadingSplash: true,
        });
      }
    );
    return () => {
      eventService.unsubscribe(subscription);
    };
  }, []);
};
